import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';

const PHONE_ROW_HEIGHT = 60;
const DEFAULT_MIN_ROW_HEIGHT = 48;

export const useSupportInfoMinRowHeight = (): number =>
  useIsMobileBottomNavLayout() ? PHONE_ROW_HEIGHT : DEFAULT_MIN_ROW_HEIGHT;
